import React, { FunctionComponent, HTMLProps } from "react";
import { useLottie } from "lottie-react";

interface IAnimateLoaderProps extends HTMLProps<"div"> {
    LoaderAnimation: any;
    Loop?: boolean;
}

const defaultProps: IAnimateLoaderProps = {
    Loop: true,
    LoaderAnimation: {}
};

const AvatarLoaderComponent: FunctionComponent<IAnimateLoaderProps> = (props: IAnimateLoaderProps) => {

    const options = {
        animationData: props.LoaderAnimation,
        loop: props.loop
    };

    const { View } = useLottie(options);

    return <div className={props.className || ""} style={props.style}>
        {View}
    </div>
}

AvatarLoaderComponent.defaultProps = defaultProps;

export default AvatarLoaderComponent;